import {values} from 'lodash'

import {IPrescriptionTemplate} from 'core/api/prescription'
import {daysToMs, minutesToMs} from 'core/utils/time-helpers'
import {BoosterCycles} from './booster'
import {Cycles} from './treatment'

export const TEST_SHOOTING_STARS: IPrescriptionTemplate = {
  key: 'TEST_SHOOTING_STARS',
  name: 'Test Shooting Stars',
  daysPerWeekDosage: 6, // days
  dailyDosage: minutesToMs(60),
  boosterCycle: BoosterCycles.SHOOTING_STARS_DEMO_RBR,
  treatmentCycle: Cycles.CYCLE_DEMO_A,
  duration: daysToMs(30),
}

const TEST_TIMED_TARGET: IPrescriptionTemplate = {
  key: 'TEST_TIMED_TARGET',
  name: 'Test Timed Target',
  daysPerWeekDosage: 6, // days
  dailyDosage: minutesToMs(60),
  boosterCycle: BoosterCycles.TIMED_TARGET_DEMO,
  treatmentCycle: Cycles.CYCLE_DEMO_A,
  duration: daysToMs(30),
}

/**
 * Constant contrast treatment used in C-AM-1D. Leverages
 * the C-AM-1C contrast treatment, new dichoptic masks, and
 * AEBs w/ delay.
 *
 * Created according to Scott Xiao on 2017-10-03
 */
const CAM1D_CONST_CONTRAST: IPrescriptionTemplate = {
  key: 'CAM1D_CONST_CONTRAST',
  name: 'C-AM-1D Constant Contrast',
  daysPerWeekDosage: 6,
  dailyDosage: minutesToMs(60),
  boosterCycle: BoosterCycles.CAM1D__1,
  treatmentCycle: Cycles.CYCLE_CAM1D_CONST_CONTRAST,
  duration: daysToMs(6 * 30),
}

/**
 * Incrementing contrast treatment used in C-AM-1D. Leverages
 * the incrementing contrast function, new dichoptic masks, and
 * AEBs w/ delay.
 *
 * Created according to Scott Xiao on 2017-10-03
 */
const CAM1D_INC_CONTRAST: IPrescriptionTemplate = {
  key: 'CAM1D_INC_CONTRAST',
  name: 'C-AM-1D Incrementing Contrast',
  daysPerWeekDosage: 6,
  dailyDosage: minutesToMs(60),
  boosterCycle: BoosterCycles.CAM1D__1,
  treatmentCycle: Cycles.CYCLE_CAM1D_INC_CONTRAST,
  duration: daysToMs(6 * 30),
}

const CAM1D_2_CONST_CONTRAST: IPrescriptionTemplate = {
  key: 'CAM1D_2_CONST_CONTRAST',
  name: 'C-AM-1D v2 Constant Contrast',
  daysPerWeekDosage: 6,
  dailyDosage: minutesToMs(60),
  boosterCycle: BoosterCycles.CAM1D__1,
  treatmentCycle: Cycles.CYCLE_CAM1D_2_CONST_CONTRAST,
  duration: daysToMs(6 * 30),
}

// Exact copy of CAM1D_2_CONST_CONTRAST, except with no AEBs.
const CAM1D_3_CONST_CONTRAST: IPrescriptionTemplate = {
  key: 'CAM1D_3_CONST_CONTRAST',
  name: 'C-AM-1D v3 Constant Contrast',
  daysPerWeekDosage: 6,
  dailyDosage: minutesToMs(60),
  boosterCycle: BoosterCycles.NO_BOOSTERS,
  treatmentCycle: Cycles.CYCLE_CAM1D_2_CONST_CONTRAST,
  duration: daysToMs(6 * 30),
}

/**
 * Exact copy of CAM1D_2_CONST_CONTRAST except with CAM1C dichoptic masks.
 * i.e. exact copy of CAM1C constant contrast treatment
 */
const CAM1D_4_CONST_CONTRAST: IPrescriptionTemplate = {
  key: 'CAM1D_4_CONST_CONTRAST',
  name: 'C-AM-1D v4 Constant Contrast',
  daysPerWeekDosage: 6,
  dailyDosage: minutesToMs(60),
  boosterCycle: BoosterCycles.NO_BOOSTERS,
  treatmentCycle: Cycles.CYCLE_CAM1C,
  duration: daysToMs(6 * 30),
}

/**
 * Exact copy of CAM1D_4_CONST_CONTRAST, simply aliased for clarity in the CAM2 study
 */
const CAM2_CONST_CONTRAST: IPrescriptionTemplate = {
  ...CAM1D_4_CONST_CONTRAST,
  key: 'CAM2_CONST_CONTRAST',
  name: 'C-AM-2 Constant Contrast',
}

const PrescriptionTemplates = [
  TEST_SHOOTING_STARS,
  TEST_TIMED_TARGET,
  CAM1D_CONST_CONTRAST,
  CAM1D_INC_CONTRAST,
  CAM1D_2_CONST_CONTRAST,
  CAM1D_3_CONST_CONTRAST,
  CAM1D_4_CONST_CONTRAST,
  CAM2_CONST_CONTRAST,
]

export const PrescriptionTemplatesByKey = values(PrescriptionTemplates).reduce<{[key: string]: IPrescriptionTemplate}>(
  (byKey, template) => ({
    ...byKey,
    [template.key]: template,
  }),
  {},
)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/prescription/templates.ts